import script from "./ApiQuotaOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiQuotaOverview.vue?vue&type=script&setup=true&lang=js"

import "./ApiQuotaOverview.vue?vue&type=style&index=0&id=70522bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70522bbc"]])

export default __exports__